export const ENVELOPES_LIST = "ENVELOPES_LIST";
export const ENVELOPES_CREATE = "ENVELOPES_CREATE";
export const ENVELOPES_UPDATE = "ENVELOPES_UPDATE";
export const ENVELOPES_DELETE = "ENVELOPES_DELETE";
export const ENVELOPES_SHOW = "ENVELOPES_SHOW";
export const ENVELOPES_UPDATE_STATUS= "ENVELOPES_UPDATE_STATUS";
export const ENVELOPES_TYPE_LIST = "ENVELOPE_TYPE_LIST";
export const ENVELOPES_SENDER_ID_LIST = "ENVELOPE_SENDER_ID_LIST";
